import { Directive, HostListener, inject } from '@angular/core';

import { TableViewOptionsService } from '../services/table-view-options.service';

@Directive({
	selector: '[svgFrontendsPageSize]',
	standalone: false,
})
export class PageSizeDirective {
	private tableViewOptionsService = inject(TableViewOptionsService);

	@HostListener('click', ['$event']) onClick(event: any): void {
		if (!!event.target.value) {
			const pageSize: number = event.target.value.split(': ')[1];
			this.tableViewOptionsService.setPageSize(pageSize);
		}
	}
}
